export default __webpack_public_path__ + "static/media/InactiveDigest.cdd95003.svg";